import { H1 } from '../../../styles/FontStyles';
import { colors } from '../../../styles/GlobalStyles';
import { Section1Wrapper } from '../Home.styled';

import { Button } from 'components/Button/Button';
import { Div } from '../../../styles/Styles';
import { HeroLogo, Icon } from '../../../styles/svg';

import { ModalComponent } from 'components/Modal/Modal';
import { Video } from '../../../components/video/video';
import { useState } from 'react';
import video from '../../../assets/images/videoThumbnail.png';
import { AnimatedDiv } from 'components/Animation/Animation';
import { backofficeLink } from 'helpers/helpers';

export const Section1 = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Section1Wrapper>
      <div id='section1'>
        <AnimatedDiv $m='0 100px' $mSM='0 20px' $flex $column $gap='50px'>
          <Div $flex $alignEnd $centerSM $between $gap='50px' $columnSM>
            <Icon>
              <HeroLogo />
            </Icon>
            <img
              onClick={() => setIsOpen(true)}
              src={video}
              alt='united one video'
            />
          </Div>
          <H1 centerSM mb='12' color={colors.white}>
            <b>Pre Launch Phase</b>
            <br /> Secure Your Position
          </H1>
          <Div $flex $centerSM>
            <a href={backofficeLink} target='_blank' rel='noopener noreferrer'>
              <Button $negative $height='50px'>
                Go To Launch
              </Button>
            </a>
          </Div>
        </AnimatedDiv>
        {/* <Section1Image1 src={image1} alt='all in one' /> */}
      </div>
      <ModalComponent noBackground isOpen={isOpen} setIsOpen={setIsOpen}>
        <Video src='https://www.youtube.com/watch?v=RWkTun7o6gg' />
      </ModalComponent>
    </Section1Wrapper>
  );
};
